import { render, staticRenderFns } from "./cash-gift-view.vue?vue&type=template&id=d8b4125c&scoped=true&"
import script from "./cash-gift-view.vue?vue&type=script&lang=js&"
export * from "./cash-gift-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b4125c",
  null
  
)

export default component.exports